const styles = () => ({
  section: {
    borderBottom: '1px solid rgba(155,173,188,0.30)',
    '&:last-of-type': {
      borderBottom: 'none',
    },
    display: 'flex',
    flexDirection: 'column',
  },

  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 8,
    gap: '8px',
  },

  app: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 322,
    height: 48,
    cursor: 'pointer',
    padding: '0 12px',

    '&:hover': {
      backgroundColor: '#fafbfc',

      '& $arrow': {
        display: 'block',
      },
    },
  },

  appDetailContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  appIcon: {
    display: 'block',
    flex: 'none',
    height: 36,
    width: 36,
    marginRight: 10,
    filter:
      'drop-shadow(0 0 1px rgba(155,173,188,.4)) drop-shadow(0 1px 1px rgba(155,173,188,.2))',

    '& g path#hub-icon-top, & g path#hub-icon-right, & g path#mark-icon-top, & g path#mark-icon-right, & path#seg-icon-top, & path#seg-icon-right, & path#sf-icon-top, & path#sf-icon-right': {
      stroke: 'rgba(89, 97, 104, .05)',
      strokeWidth: '0.5px',
    },
  },

  appDetail: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '32px',
  },

  appTitle: {
    color: '#596168',
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '14px',
  },

  appLinkText: {
    color: '#9badbc',
    fontSize: 14,
    lineHeight: '14px',
  },

  arrow: {
    display: 'none',
  },
});

export default styles;
